import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetShippingLinesByOrderInput } from './GetShippingLinesByOrderInput';
import { GetShippingLinesByOrderOutput } from './GetShippingLinesByOrderOutput';

export class GetShippingLinesByOrderService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GetShippingLinesByOrderInput): Promise<Result<GetShippingLinesByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetShippingLinesByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/shipping-lines`);
    return promise;
  }
}